module.exports = __webpack_public_path__ + "static/img/img-kaft.1b813dda.png";